import { kAcceptedFilesList } from '@/constants/constants-gcs'

/** Mirrors standard ingest's supported types and aliases in paxton_app/file_pipeline/type_policy.py. */
export const supportedUploadFileTypes: Record<string, string[]> = {
  ...kAcceptedFilesList,
  'text/plain': ['.txt', '.text', '.log'],
  'text/csv': ['.csv', '.tsv'],
  'text/html': ['.html', '.htm'],
  'application/rtf': ['.rtf'],
  'application/vnd.oasis.opendocument.text': ['.odt'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
  'image/tiff': ['.tif', '.tiff'],
  'image/heic': ['.heic'],
}

const extensions = new Set(Object.values(supportedUploadFileTypes).flat())

export function isSupportedUploadFile(file: File): boolean {
  const extension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase()
  return extensions.has(extension) || Object.hasOwn(supportedUploadFileTypes, file.type)
}
